import styled from 'styled-components';

const StyledCard = styled.div`
  width: 100%;
  border-radius: 12px;
  background-color: ${props => props.theme.colors.surface.primary};
`;

export default StyledCard;
